export default __webpack_public_path__ + "static/media/stacked_rooms_dark.a82297f6.svg";